import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { openClose } from '@core/animations/animations';
import { Keys, KeysPossession } from '@models/matter';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Select } from '@ngxs/store';
import { MatterDispatch } from '@state/matter';

import { SelectedMatter } from '@state/matter/matter.selectors';
import { cloneDeep } from 'lodash';
import { Observable } from 'rxjs';
import { RadioGroupItem } from 'src/app/shared/atomic/atoms/radio-group/radio-group.component';

@UntilDestroy()
@Component({
	selector: 'app-keys-modal',
	templateUrl: './keys-modal.component.html',
	styleUrls: ['./keys-modal.component.scss'],
	animations: [openClose()],
	standalone: false,
})
export class KeysModalComponent implements OnInit {
	@Select(SelectedMatter.keys) keys$: Observable<Keys>;
	@SelectSnapshot(SelectedMatter.id) matterId: string;

	public keysPossessionOptions: RadioGroupItem<KeysPossession>[] = [
		{ label: 'Vendor', value: KeysPossession.VENDOR },
		{ label: "Vendor's broker", value: KeysPossession.VENDOR_BROKER },
		{ label: "Vendor's lawyer", value: KeysPossession.VENDOR_LAWYER },
		{ label: 'Lockbox', value: KeysPossession.LOCKBOX },
	];

	public keys = {
		released: false,
		possession: KeysPossession.VENDOR,
		lockboxCode: '',
		note: '',
	};

	public KeysPossessions = KeysPossession;

	constructor(
		private dialogRef: MatDialogRef<KeysModalComponent>,
		private matterDispatch: MatterDispatch,
	) {}

	ngOnInit(): void {
		this.keys$.pipe(untilDestroyed(this)).subscribe((_keys) => {
			if (_keys) {
				this.keys = cloneDeep(_keys);
			}
		});
	}

	save() {
		this.matterDispatch.SetKeys(this.matterId, this.keys);
		this.dialogRef.close();
	}

	close() {
		this.dialogRef.close();
	}
}
